<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 header">
      <h4><b>{{ 'pages.userModification.userManagement' | translate }}</b></h4>
      <h4>{{ 'pages.userModification.activeUser' | translate }}</h4>
    </div>
  </div>

  <div class="steps">
    <div class="row">
      <div class="col-md-12">
        <user-management-find-exist-user *ngIf="!userSelected" (User)="onUserSelect($event)"></user-management-find-exist-user>
        <user-management-user-settings *ngIf="userSelected" [user]="user" [type]="1"></user-management-user-settings>
      </div>
    </div>
  </div>
</div>
